export default "__VITE_ASSET__CDhYnfBf__"